import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import { hasUserGroup } from "../../ipermissions-context/ipermissions-context.functions";
import { UserGroup } from "../../../../../constants/types";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const campaignManagerGroupPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // console.log("checkCampaignManagerPolicy -->");
  if (hasUserGroup(context, UserGroup.CAMPAIGN_MANAGERS)) {
    // console.log("checkCampaignManagerPolicy --> TRUE");
    // There are no FE specific access add-ons in the matrix
  }

  if (next) {
    return next(context, permissions);
  }
};
